import React from 'react';
import PropTypes from 'prop-types';
import './ServicesDetails.css';

const ServicesDetails = ({ dataList = [] }) => {
  if (!dataList.length) return <p>No services available.</p>;

  return (
    <>
      {dataList.map((data, index) => {
        const {
          name,
          details,
          Points = [],
          ContentPhoto
        } = data;

        const reverse = index % 2 !== 0;

        return (
          <div
            key={data._id}
            className={`ServicesDetails-container ${reverse ? 'reverse' : ''}`}
          >
            {/* Left or Right Image */}
            {ContentPhoto && (
              <div className="ServicesDetails-image">
                <img src={ContentPhoto} alt={name} loading="lazy" />
              </div>
            )}

            {/* Opposite Side Content */}
            <div className={`ServicesDetails-content ${reverse ? 'reverse-bg' : ''}`}>
              {name && <h2 className="ServicesDetails-title">{name}</h2>}
              {details && <p className="ServicesDetails-subtitle">{details}</p>}
              {Points.length > 0 && (
                <ul className="ServicesDetails-list">
                  {Points.map((item) => (
                    <li key={item._id}>{item.Point}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

ServicesDetails.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string,
      details: PropTypes.string,
      Points: PropTypes.arrayOf(
        PropTypes.shape({
          Point: PropTypes.string,
          _id: PropTypes.string
        })
      ),
      ContentPhoto: PropTypes.string
    })
  )
};

export default ServicesDetails;
